import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useToasts } from '../../../cdl/Toast/useToasts';
import { updateCustomerDetails } from '../../../common/api/clients/company.api';
import { queries } from '../../../common/api/queryKeys/queries';
import { translate } from '../../../common/helpers/translate.helper';

export const useCustomerDetailsEdit = () => {
    const queryClient = useQueryClient();
    const { addToast, addErrorToast } = useToasts();
    return useMutation({
        mutationFn: updateCustomerDetails,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queries.customers._def });
            addToast(translate('company.toasts.informationUpdateSuccess'));
        },
        onError: () => {
            addErrorToast(translate('company.toasts.informationUpdateError'));
        },
    });
};
